import { useEffect, useState } from 'react';
import { webplaySessionService } from '../services/webplaySessionService';

/**
 * Hook to manage webplay session tracking
 * Automatically starts session on mount and ends on unmount
 */
export const useWebplaySession = () => {
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const startSession = async () => {
      try {
        const id = await webplaySessionService.logSession();
        if (mounted) {
          setSessionId(id);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('[useWebplaySession] Failed to start session:', error);
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    startSession();

    // End session only on actual page unload, NOT on component unmount
    // This prevents session from being cleared during React Strict Mode double-renders
    const handleBeforeUnload = () => {
      webplaySessionService.endSession();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      mounted = false;
      window.removeEventListener('beforeunload', handleBeforeUnload);
      // Do NOT call endSession() here - keep session alive across component remounts
    };
  }, []);

  return {
    sessionId,
    isLoading
  };
};
